import { useState, useEffect } from "react";
import { TextField, Button, Typography, Container, Box, Card, CardContent, Link, Alert, CircularProgress, Divider } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import FacebookIcon from "@mui/icons-material/Facebook";
import AppsIcon from "@mui/icons-material/Apps";

// Güncel marka wordmark'ı (mor bi + turkuaz YAPAYZEKA) — SMS/landing ile birebir
function BrandMark({ size = 40 }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.1, justifyContent: "center" }}>
      <Box sx={{
        width: size, height: size, borderRadius: `${Math.round(size * 0.3)}px`,
        background: "linear-gradient(135deg,#9b7cf6,#7c4dff)", color: "#fff",
        fontWeight: 800, fontSize: size * 0.5, display: "flex", alignItems: "center",
        justifyContent: "center", boxShadow: "0 4px 14px rgba(124,77,255,.4)"
      }}>bi</Box>
      <Box sx={{ fontWeight: 800, fontSize: size * 0.58, letterSpacing: .3, lineHeight: 1 }}>
        <span style={{ color: "#7c4dff" }}>bi</span>
        <span style={{ background: "linear-gradient(90deg,#2fc9d6,#41dd9e)", WebkitBackgroundClip: "text", backgroundClip: "text", color: "transparent" }}>YAPAYZEKA</span>
      </Box>
    </Box>
  );
}

export default function RegisterPage() {
  const [form, setForm] = useState({ name: "", surname: "", email: "", phone: "", password: "", confirm: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [refCode, setRefCode] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  // Davet linki: /register?ref=KOD — kodu sakla, giriş sonrası Layout uygular
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) { setRefCode(ref); try { localStorage.setItem("biyz_ref", ref); } catch {} }
    const eg = new URLSearchParams(window.location.search).get("egitim");
    if (eg) { try { sessionStorage.setItem("biyz_egitim", eg); } catch {} }
    const camp = new URLSearchParams(window.location.search).get("utm_campaign");
    if (camp) { try { sessionStorage.setItem("biyz_campaign", camp); } catch {} }
  }, []);

  // Sosyal giriş: whitelist'li devplatform relay üzerinden; dönüşte /auth/social-success token ile geri döner.
  const socialLogin = (provider) => {
    const relay = "https://devplatform.biyapayzeka.com";
    window.location.href = `${relay}/api/platform/auth/${provider}?returnTo=${encodeURIComponent(window.location.origin)}`;
  };

  const handleRegister = async () => {
    if (form.password !== form.confirm) { setError("Şifreler eşleşmiyor"); return; }
    if (!form.name || !form.email || !form.password) { setError("İsim, email ve şifre zorunludur"); return; }
    if (form.password.length < 6) { setError("Şifre en az 6 karakter olmalı"); return; }
    setLoading(true); setError("");
    try {
      const res = await fetch("/api/platform/auth/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name, surname: form.surname,
          email: form.email, phone: form.phone,
          password: form.password
        }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.message || "Kayıt başarısız"); return; }
      const _eg = (() => { try { return sessionStorage.getItem("biyz_egitim"); } catch { return null; } })();
      const _camp = (() => { try { return sessionStorage.getItem("biyz_campaign"); } catch { return null; } })();
      // Kampanyadan (egitim secili) kayit olan kullanici, giristen sonra dogrudan
      // o egitimin paket ekranina (kampanya kodu otomatik uygulanmis) yonlensin —
      // eskiden /firsat pazarlama sayfasina geri donuyordu (donguye giriyor, hicbir sey atanmiyordu).
      let next = "";
      if (_eg && _camp === "firsat") {
        next = "/packages?bot=" + encodeURIComponent(_eg) + "&code=biuzman";
      } else if (_eg) {
        next = "/packages?bot=" + encodeURIComponent(_eg);
      }
      window.location.href = "/login?registered=1" + (next ? "&next=" + encodeURIComponent(next) : "");
    } catch {
      setError("Sunucuya bağlanılamadı");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box position="absolute" top={20} left={24}>
        <BrandMark size={38} />
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" py={8}>
        <Card sx={{ width: "100%", padding: 3, boxShadow: 3 }}>
          <CardContent>
            <Box sx={{ mb: 2 }}><BrandMark size={44} /></Box>
            <Typography variant="h5" align="center" gutterBottom>Kayıt Ol</Typography>
            {refCode && <Alert severity="success" sx={{ mb: 2 }}>🎁 Davetle geldin! Kayıt olunca sana <b>7 gün ücretsiz</b> ek süre tanımlanacak.</Alert>}
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField fullWidth label="İsim *" margin="normal" value={form.name} onChange={set("name")} />
              <TextField fullWidth label="Soyisim" margin="normal" value={form.surname} onChange={set("surname")} />
            </Box>
            <TextField fullWidth label="Email *" type="email" margin="normal" value={form.email} onChange={set("email")} />
            <TextField fullWidth label="Telefon" margin="normal" value={form.phone} onChange={set("phone")} />
            <TextField fullWidth label="Şifre *" type="password" margin="normal" value={form.password} onChange={set("password")} />
            <TextField fullWidth label="Şifreyi Onayla *" type="password" margin="normal" value={form.confirm} onChange={set("confirm")} />
            <Box mt={2}>
              <Button fullWidth variant="contained" color="primary" sx={{ fontWeight: "bold", height: 50 }}
                onClick={handleRegister} disabled={loading}>
                {loading ? <CircularProgress size={24} color="inherit" /> : "Kayıt Ol"}
              </Button>
            </Box>
            <Box mt={2} textAlign="center">
              <Link href="/login" variant="body2">Zaten hesabın var mı? Giriş Yap</Link>
            </Box>

            <Divider sx={{ mt: 3, mb: 1 }}>
              <Typography variant="caption" color="text.secondary">veya hesabınla bağlan</Typography>
            </Divider>

            <Box sx={{ display: "flex", gap: 1, mt: 1, justifyContent: "center" }}>
              <Button variant="outlined" startIcon={<GoogleIcon />}
                onClick={() => socialLogin("google")}
                sx={{ borderRadius: 2, flex: 1, textTransform: "none", borderColor: "#e0e0e0", color: "#555", fontSize: 12 }}>
                GOOGLE
              </Button>
              <Button variant="outlined" startIcon={<AppsIcon />}
                onClick={() => socialLogin("microsoft")}
                sx={{ borderRadius: 2, flex: 1, textTransform: "none", borderColor: "#e0e0e0", color: "#555", fontSize: 12 }}>
                MICROSOFT
              </Button>
              <Button variant="outlined" startIcon={<FacebookIcon />}
                onClick={() => socialLogin("facebook")}
                sx={{ borderRadius: 2, flex: 1, textTransform: "none", borderColor: "#e0e0e0", color: "#555", fontSize: 12 }}>
                FACEBOOK
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
}
